import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import BasketPageViewModel = Vertica.LouisPoulsen.Application.Content.Pages.Basket.Business.BasketPageViewModel;


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMethodsB2B',
  props: {
    model: null,
    selectedPaymentType: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', paymentMethod: string): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    model: BasketPageViewModel,
    selectedPaymentType: Vertica.LouisPoulsen.Application.Content.Pages.Basket.Business.PaymentMethodType
}



const paymentMethods = computed<any>(() => {
    return props.model.paymentMethodSelectItems;
});

const selectedPaymentMethod = ref<string>(props.selectedPaymentType.toString());



function onPaymentMethodChange(paymentMethod: string) {
    selectedPaymentMethod.value = paymentMethod;
    emit('input', paymentMethod);
}


return { __sfc: true,props, paymentMethods, selectedPaymentMethod, emit, onPaymentMethodChange }
}

})